/* tslint:disable:max-line-length */
import gql from 'graphql-tag';

export const EmailLogin = gql`
  mutation EmailLogin($password: String!, $username: String!) {
    emailLogin(password: $password, username: $username) {
      token
    }
  }
`;
